import { ReactNode } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, IconButton, SxProps, Typography, useTheme } from '@mui/material';

import { colors } from 'components/Colors';
import { IconClose, IconInfo } from 'components/Icon';

interface InfoComponentProps {
  onClose?: () => void;
  children: ReactNode;
  iconBoxSxProps?: SxProps;
  textBoxSxProps?: SxProps;
}

const InfoComponent = ({
  children,
  onClose,
  iconBoxSxProps,
  textBoxSxProps
}: InfoComponentProps) => {
  const theme = useTheme();

  return (
    <Grid size={12}>
      <Box
        display="flex"
        sx={{
          backgroundColor: `${colors.green.lightTeal.value}`,
          border: `2px ${theme.customPalette.cobalt.alternative} solid`,
          color: theme.customPalette.cobalt.alternative
        }}
      >
        <Box pl={2.5} pr={1.5} alignSelf="center" sx={iconBoxSxProps}>
          <IconInfo sx={{ fontSize: 14 }} />
        </Box>
        <Box
          flexGrow={1}
          py={1.5}
          sx={{ alignContent: 'center', ...textBoxSxProps }}
        >
          <Typography
            variant="body2"
            color={`${theme.customPalette.cobalt.alternative}`}
          >
            {children}
          </Typography>
        </Box>
        <Box p={1.5}>
          {onClose && (
            <IconButton sx={{ padding: 0.3 }} onClick={onClose}>
              <Typography color={`${theme.customPalette.cobalt.alternative}`}>
                <IconClose
                  sx={{
                    border: '1px solid',
                    borderRadius: 50,
                    fontSize: 14,
                    padding: 0.2
                  }}
                />
              </Typography>
            </IconButton>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default InfoComponent;
